import React from 'react';
import { Phone, Mail, Clock, Store } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';

const Contact = () => {
  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-white to-yellow-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Franchise Section */}
        <div id="franchise" className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
              Franchise <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500">Opportunities</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Join the Ambarsariya family and bring authentic North Indian flavors to your city
            </p>
          </div>

          <div className="bg-gradient-to-br from-yellow-400 via-yellow-300 to-pink-400 rounded-3xl p-8 md:p-12 shadow-2xl">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <Store className="w-16 h-16 text-gray-800 mb-6" />
                <h3 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
                  Become a Franchise Partner
                </h3>
                <p className="text-gray-700 text-lg mb-6 leading-relaxed">
                  Be part of a growing brand that celebrates authentic North Indian vegetarian cuisine. 
                  We offer complete support, training, and a proven business model to ensure your success.
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-center gap-3 text-gray-800 font-semibold">
                    <div className="w-2 h-2 bg-gray-800 rounded-full"></div>
                    Proven Business Model
                  </li>
                  <li className="flex items-center gap-3 text-gray-800 font-semibold">
                    <div className="w-2 h-2 bg-gray-800 rounded-full"></div>
                    Complete Training & Support
                  </li>
                  <li className="flex items-center gap-3 text-gray-800 font-semibold">
                    <div className="w-2 h-2 bg-gray-800 rounded-full"></div>
                    Marketing Assistance
                  </li>
                  <li className="flex items-center gap-3 text-gray-800 font-semibold">
                    <div className="w-2 h-2 bg-gray-800 rounded-full"></div>
                    Quality Control Systems
                  </li>
                </ul>
              </div>
              <div className="bg-white rounded-2xl p-8 shadow-xl">
                <h4 className="text-2xl font-bold text-gray-800 mb-6 text-center">
                  Get Started Today
                </h4>
                <div className="space-y-4">
                  <div className="flex items-center gap-4 p-4 bg-yellow-50 rounded-lg">
                    <Phone className="w-6 h-6 text-yellow-600" />
                    <div>
                      <p className="text-sm text-gray-600">Call us for franchise</p>
                      <a
                        href="tel:+918799997457"
                        className="text-lg font-bold text-gray-800 hover:text-yellow-600 transition-colors">

                        +91 87999 97457
                      </a>
                    </div>
                  </div>
                  <Button
                    onClick={() => window.open('tel:+918799997457')}
                    className="w-full bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-900 hover:to-black text-white font-bold py-6 text-lg shadow-lg hover:shadow-xl transition-all">

                    <Phone className="w-5 h-5 mr-2" />
                    Call Now for Franchise
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">
            Get in <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-pink-500">Touch</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-yellow-400 to-pink-400 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Visit us or reach out for orders, catering, or any inquiries
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          <Card className="border-2 border-yellow-200 hover:border-yellow-400 transition-colors shadow-lg hover:shadow-xl">
            <CardHeader>
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-100 to-pink-100 rounded-lg flex items-center justify-center mb-4">
                <Phone className="w-6 h-6 text-yellow-600" />
              </div>
              <CardTitle>Phone</CardTitle>
              <CardDescription>Give us a call</CardDescription>
            </CardHeader>
            <CardContent>
              <a
                href="tel:+918799997457"
                className="text-lg font-bold text-gray-800 hover:text-yellow-600 transition-colors">

                +91 87999 97457
              </a>
            </CardContent>
          </Card>

          <Card className="border-2 border-pink-200 hover:border-pink-400 transition-colors shadow-lg hover:shadow-xl">
            <CardHeader>
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-100 to-pink-100 rounded-lg flex items-center justify-center mb-4">
                <Mail className="w-6 h-6 text-pink-600" />
              </div>
              <CardTitle>Email</CardTitle>
              <CardDescription>Send us a message</CardDescription>
            </CardHeader>
            <CardContent>
              <a
                href="mailto:ambarsariya.info@gmail.com"
                className="text-lg font-bold text-gray-800 hover:text-pink-600 transition-colors break-all">ambarsariya.info@gmail.com


              </a>
            </CardContent>
          </Card>

          <Card className="border-2 border-pink-200 hover:border-pink-400 transition-colors shadow-lg hover:shadow-xl">
            <CardHeader>
              <div className="w-12 h-12 bg-gradient-to-br from-yellow-100 to-pink-100 rounded-lg flex items-center justify-center mb-4">
                <Clock className="w-6 h-6 text-pink-600" />
              </div>
              <CardTitle>Hours</CardTitle>
              <CardDescription>We're open</CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-lg font-bold text-gray-800">11:00 AM - 11:00 PM

              </p>
              <p className="text-sm text-gray-600 mt-1">All days</p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>);

};

export default Contact;